module.exports = __webpack_public_path__ + "static/media/map_type_roadmap.a3c9dfe8.svg";